<av-option-block
  *ngFor="let o of question.options; index as i"
  [label]="o.body"
  [active]="isActive(o)"
  [attr.data-tid]="'survey/single/option/' + i"
>
  <input
    required
    type="radio"
    name="{{ question.id }}"
    [ngModel]="item().choice"
    [value]="o.score || o.body"
    (ngModelChange)="optionChange($event)"
  />
</av-option-block>
<div class="form-error" *ngIf="isError()" translate>Required</div>
